import React, { useContext, useReducer } from 'react'
import { t } from 'i18next';
import { logout } from '../../services/login';
import BuildingsManagementContext from './BuildingsManagementContext';
import BuildingsManagementReducer from './BuildingsManagementReducer';
import { createBuildingService, deleteBuildingService, editBuildingService, getListOfBuildingstService, getSettingMenuService, setSettingService } from '../../services/Settings';
import { getTenantInfoByKey } from '../../helpers/helpers';
import InstanceContext from '../InstanceContext/InstanceContext';

const BuildingsManagementState = ({ children }) => {
    const buildingName = getTenantInfoByKey('building_name');
    const openingName = getTenantInfoByKey('opening_name');

    const { instanceInfoGet } = useContext(InstanceContext);

    const initialState = {
        buildingsToConfig: [],
        buildingData: {
            buildingCode: '',
            buildingDescription: '',
            buildingEnabled: 1,
            openingCode: null
        },
        isFetching: false,
        error: {
            ok: false,
            text: ''
        },
        responseBuildingService: {
            show: false,
            type: '',
            text: '',
        }
    }

    const [state, dispatch] = useReducer(BuildingsManagementReducer, initialState);

    const setFetching = (value) => {
        dispatch({
            type: 'SET_FETECHING',
            payload: value
        });
    }

    const getBuildingsManagement = async (text) => {
        try {
            setFetching(true);
            const param = text ? `searchText=${text}` : null
            const items = await getListOfBuildingstService(param);

            items.data.response.forEach(element => {
                element.openingCode = element.Opening ? element.Opening.code : null;
            });

            if (items.ok) {
                dispatch({
                    type: 'GET_BUILDINGS',
                    payload: {
                        buildingsToConfig: items.data.response,
                        responseBuildingService: {
                            show: false,
                            type: 'SUCCESS',
                            text: '',
                        }
                    }
                })
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'GET_BUILDINGS',
                    payload: {
                        buildingsToConfig: state.buildingsToConfig,
                        responseBuildingService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'GET_BUILDINGS',
                payload: {
                    resources: state.buildingsToConfig,
                    responseBuildingService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const getBuilding = async (id) => {
        try {
            setFetching(true);
            const param = id ? `buildingId=${id}` : null
            const items = await getListOfBuildingstService(param);

            const element = items.data.response[0];

            element.openingCode = element.Opening ? element.Opening.code : null;

            if (items.ok) {
                setBuildingData(element)
                return element
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'GET_BUILDINGS',
                    payload: {
                        buildingsToConfig: state.buildingsToConfig,
                        responseBuildingService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'GET_BUILDINGS',
                payload: {
                    resources: state.buildingsToConfig,
                    responseBuildingService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const createBuilding = async (building) => {
        try {
            setFetching(true);

            const items = await createBuildingService(building);

            if (items.ok) {
                dispatch({
                    type: 'CRUD_BUILDING',
                    payload: {
                        responseBuildingService: {
                            show: true,
                            type: 'SUCCESS',
                            text: `${buildingName} ${t('CREATED_SUCCESSFULLY')}`,
                        }
                    }
                })

                if (state.buildingsToConfig.length === 0) {
                    instanceInfoGet();
                    const menu = await getSettingMenuService();
                    localStorage.setItem('settingMenu', JSON.stringify(menu.data.response));
                }

            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('CODE_ALREADY_EXIST');
                        break;
                    case 'NOT_ACCESS_OPENING':
                        errorMsg = `${openingName} ${t('NOT_ACCESS_OPENING')}`;
                        break;
                    case 'RESOURCES_IN_WITHOUT_OPENING':
                        errorMsg = `${t('NOT_ENABLE_BUILDING_WITHOUT_BUILDING')} ${buildingName}  ${t('ASSIGNED')}`;
                        break;
                    case 'RESOURCES_IN_OPENING':
                        errorMsg = `${t('CANNOT_CREATE_THE')} "${buildingName}"  ${t('BECAUSE_EXISTING_RESOURCES_IN')} "${getTenantInfoByKey('opening_name')}"`;
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'CRUD_BUILDING',
                    payload: {
                        responseBuildingService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg
                        },
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'CRUD_BUILDING',
                payload: {
                    responseBuildingService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR')
                    },
                }
            });
        }
    }

    const editBuilding = async (building) => {
        try {
            setFetching(true);

            building.enabled = building.enabled ? 1 : 0;
            const items = await editBuildingService(building);

            if (items.ok) {
                dispatch({
                    type: 'CRUD_BUILDING',
                    payload: {
                        responseBuildingService: {
                            show: true,
                            type: 'SUCCESS',
                            text: `${buildingName} ${t('EDITED_SUCCESSFULLY')}`,
                        }
                    }
                })
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'RESOURCES_IN_BUILDING':
                        errorMsg = t('RESOURCES_IN_BUILDING_ERROR');
                        break;
                    case 'RESOURCES_IN_WITHOUT_OPENING':
                        errorMsg = `${t('NOT_ENABLE_BUILDING_WITHOUT_BUILDING')} ${buildingName}  ${t('ASSIGNED')}`;
                        break;
                    case 'RESOURCES_IN_OPENING':
                        errorMsg = `${t('CANNOT_ENABLE_THE')} "${buildingName}"  ${t('BECAUSE_EXISTING_RESOURCES_IN')} "${getTenantInfoByKey('opening_name')}"`;
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'CRUD_BUILDING',
                    payload: {
                        responseBuildingService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'CRUD_BUILDING',
                payload: {
                    responseBuildingService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const deleteBuilding = async (query) => {
        try {
            setFetching(true);

            const items = await deleteBuildingService(query);

            if (items.ok) {
                dispatch({
                    type: 'CRUD_BUILDING',
                    payload: {
                        responseBuildingService: {
                            show: true,
                            type: 'SUCCESS',
                            text: `${buildingName} ${t('DELETED_SUCCESSFULLY')}`,
                        }
                    }
                })

                if (state.buildingsToConfig.length === 1) {
                    instanceInfoGet();
                    const menu = await getSettingMenuService();
                    localStorage.setItem('settingMenu', JSON.stringify(menu.data.response));
                }
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('CANT_DELETE_FOR_ENTRYS');
                        break;
                    case 'BUILDINGS_ASSIGNED_PEOPLE_TO_VISIT':
                        errorMsg = t('CANT_DELETE_BUILDING_HAS_PERSON_ERROR');
                        break;
                    case 'BUILDINGS_ASSIGNED_TO_USER':
                        errorMsg = t('CANT_DELETE_FOR_ASSIGNED_TO_USER');
                        break;
                    case 'BUILDING_HAS_AREAS':
                        errorMsg = t('CANT_DELETE_BUILDING_HAS_AREAS_ERROR');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'CRUD_BUILDING',
                    payload: {
                        responseBuildingService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'CRUD_BUILDING',
                payload: {
                    responseBuildingService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const cleanBuildingState = () => {
        dispatch({
            type: 'CLEAN_BUILDING_STATE',
        });
    }

    const removeWarningModal = (type) => {
        dispatch({
            type: 'CLEAN_BUILDING_ERROR',
        });
    }

    const setBuildingData = (building) => {
        dispatch({
            type: 'SET_BUILDING_DATA',
            payload: building
        });
    }

    const changeNameOfBuildings = async (value) => {
        try {
            setFetching(true);

            const items = await setSettingService(value);

            if (items.ok) {
                const textSuccess = t('EDITED_SUCCESSFULLY')
                let textWithUpperCase = textSuccess.charAt(0).toUpperCase() + textSuccess.slice(1);
                dispatch({
                    type: 'CRUD_BUILDING',
                    payload: {
                        responseBuildingService: {
                            show: true,
                            type: 'SUCCESS',
                            text: textWithUpperCase,
                        }
                    }
                })
                const menu = await getSettingMenuService();
                const tenantInfo = JSON.parse(localStorage.getItem('tenant'));
                tenantInfo.building_name = value.setting_value;
                localStorage.setItem('tenant', JSON.stringify(tenantInfo));
                localStorage.setItem('settingMenu', JSON.stringify(menu.data.response));
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'RESOURCES_IN_BUILDING':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'CRUD_BUILDING',
                    payload: {
                        responseBuildingService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'CRUD_BUILDING',
                payload: {
                    responseBuildingService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    return (
        <BuildingsManagementContext.Provider
            value={{
                buildingsManagementState: state,
                getBuildingsManagement,
                deleteBuilding,
                createBuilding,
                cleanBuildingState,
                removeWarningModal,
                setBuildingData,
                editBuilding,
                changeNameOfBuildings,
                getBuilding
            }}
        >
            {children}
        </BuildingsManagementContext.Provider>
    )
}

export default BuildingsManagementState